import { render, staticRenderFns } from "@/style-guide/partials/groupFilter/groupFilter.pug?vue&type=template&id=bfe2f9c8&scoped=true&lang=pug&external"
import script from "./groupFilter.vue?vue&type=script&lang=ts"
export * from "./groupFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe2f9c8",
  null
  
)

export default component.exports